import { ICallAndSetData } from "@/services/api-service/interface";
import { getSetApiData } from "@/services/api-service/get-set-api-data";
import { EHttpMethod } from "@/services/api-service/enums";
import {
  IDynamicRowData,
  IMaterialTableFilteringValue,
} from "@/widgets/materials-widget/interface";

const GET_MATERIAL_CATEGORIES_URL =
  "/v1/printhouse-materials/GetPrintHouseMaterialCategories";
const GET_MATERIAL_CATEGORY_DATA_URL =
  "/v1/printhouse-materials/GetPrintHouseMaterialCategoryData";
const GET_MATERIAL_CATEGORY_DATA_NEW_URL =
  "/v1/printhouse-materials/get-print-house-material-category-data-new";
const UPDATE_MATERIAL_PROPS_URL =
  "/v1/printhouse-materials/updatePrintHouseMaterial";
const UPDATE_MATERIALS_PROPS_URL =
  "/v1/printhouse-materials/updatePrintHouseMaterials";
const ADD_MATERIAL_CATEGORY_URL =
  "/v1/printhouse-materials/add-printhouse-material-category";
const UPDATE_MATERIAL_CATEGORY_ORDER_URL =
  "/v1/printhouse-materials/update-print-house-categories-order";
const UPDATE_MATERIAL_ORDER_FOR_CATEGORY_URL =
  "/v1/materials/update-categories-order";
const DELETE_MATERIAL_CATEGORY_URL =
  "/v1/printhouse-materials/delete-printhouse-material-category";
const ADD_MATERIAL_CATEGORY_ROW_URL =
  "/v1/printhouse-materials/add-printhouse-material-category-row";
const ADD_PRINTHOUSE_MATERIAL_ROW_URL =
  "/v1/printhouse-materials/add-printhouse-material-row";
const UPDATE_MATERIAL_DISPLAY_NAME_URL =
  "/v1/printhouse-materials/update-print-house-material-display-name";
const DUPLICATE_MATERIAL_CATEGORY_URL =
  "/v1/printhouse-materials/duplicate-print-house-material-category";

const DELETE_MATERIAL_CATEGORY_Row_URL =
  "/v1/printhouse-materials/delete-printhouse-material-category-row";
const DOWNLOAD_MATERIAL_EXCEL_FILE =
  "/v1/printhouse-materials/download-material-excel";
const UPLOAD_MATERIAL_EXCEL_FILE =
  "/v1/printhouse-materials/upload-material-excel-file";
const DOWNLOAD_MATERIAL_ROW_EXCEL_FILE =
  "/v1/printhouse-materials/download-material-row-excel";
const DOWNLOAD_MATERIAL_INVENTORIES_EXCEL_FILE =
  "/v1/printhouse-materials/download-material-inventories-excel";
const DOWNLOAD_MATERIAL_INVENTORIES_JOBS_EXCEL_FILE =
  "/v1/printhouse-materials/download-material-inventories-jobs-excel";
const UPLOAD_MATERIAL_1_ROW_EXCEL_FILE =
  "/v1/printhouse-materials/upload-material-one-row-excel";
const GET_MATERIAL_EXCEL_TEMPLATE_COLUMNS =
  "/v1/printhouse-materials/material-excel-template-columns";


const GET_MATERIALS_SIZES_URL = "/v1/printhouse-materials/get-materials-sizes";
const GET_SUPPLIER_INVENTORIES_URL = "/v1/printhouse-materials/get-supplier-inventories";
const GET_PURCHASE_PRICING_URL = "/v1/printhouse-materials/get-purchase-pricing";

// New supplier inventory management endpoints
const GET_SUPPLIER_INVENTORY_USAGE_URL = "/v1/printhouse-materials/get-supplier-inventory-usage";
const DELETE_SUPPLIER_INVENTORY_USAGE_URL =
  "/v1/printhouse-materials/delete-supplier-inventory-usage";
const UPDATE_SUPPLIER_INVENTORY_USAGE_STATUS_URL =
  "/v1/printhouse-materials/update-supplier-inventory-usage-status";
const UPDATE_SUPPLIER_INVENTORY_USAGE_QUANTITY_URL =
  "/v1/printhouse-materials/update-supplier-inventory-usage-quantity";
const DELETE_SUPPLIER_INVENTORY_URL = "/v1/printhouse-materials/delete-supplier-inventory";
const DELETE_PRINTHOUSE_MATERIAL_SUPPLIER_URL = "/v1/printhouse-materials/delete-print-house-material-supplier";
const REORDER_PRINTHOUSE_MATERIALS_URL = "/v1/printhouse-materials/reorder-print-house-materials";
const REORDER_PRINTHOUSE_SUPPLIER_INVENTORIES_URL = "/v1/printhouse-materials/reorder-supplier-inventories";
const REORDER_PRINTHOUSE_MATERIAL_SUPPLIER_URL = "/v1/printhouse-materials/reorder-print-house-material-supplier";
const UPDATE_SUPPLIER_INVENTORY_URL = "/v1/printhouse-materials/update-supplier-inventory";
const ADD_SUPPLIER_INVENTORY_URL = "/v1/printhouse-materials/add-supplier-inventory";
const UPDATE_PRINT_HOUSE_MATERIAL_ROW_URL = "/v1/printhouse-materials/update-print-house-material-row";
const UPDATE_PRINT_HOUSE_MATERIALS_ROWS_URL = "/v1/printhouse-materials/update-print-house-materials-rows";
const UPDATE_PRINT_HOUSE_MATERIAL_SUPPLIER_URL = "/v1/printhouse-materials/update-print-house-material-supplier";
const ADD_PRINT_HOUSE_MATERIAL_SUPPLIER_URL = "/v1/printhouse-materials/add-print-house-material-supplier";
const UPDATE_SUPPLIER_INVENTORIES_ACTION_URL = "/v1/printhouse-materials/update-supplier-inventories-action";
const UPDATE_PRINTHOUSE_MATERIAL_SUPPLIERS_ACTION_URL = "/v1/printhouse-materials/update-printhouse-material-suppliers-action";
const CALCULATE_PRICE_URL = "/v1/printhouse-materials/calculate-price";
const ADD_SUPPLIER_INVENTORY_FOR_PURCHASE_ORDER_URL = "/v1/erp-service/documents/add-supplier-inventory-for-purchase-order";
const RE_CALCULATE_DOCUMENT_ITEMS_DATA_FROM_ROW_MATERIALS_URL = "/v1/printhouse-materials/re-calculate-document-items-data-from-row-materials";
const ADD_DOCUMENT_ITEMS_FROM_MATERIAL_ROWS_URL =
  "/v1/printhouse-materials/add-document-items-from-material-rows";
const HAS_PURCHASE_ORDER_INVENTORY_URL = "/v1/printhouse-materials/has-purchase-order-inventory";
const RETURN_INVENTORY_USAGES_URL =
  "/v1/printhouse-materials/return-inventory-usages";
const GET_LAST_PRINT_HOUSE_MATERIAL_CODE_URL =
  "/v1/printhouse-materials/get-last-print-house-material-code";

const getPrintHouseMaterialCategoriesApi: ICallAndSetData = async (
  callApi,
  setState,
  material: string
) => {
  return await getSetApiData(
    callApi,
    EHttpMethod.GET,
    `${GET_MATERIAL_CATEGORIES_URL}?materialKey=${material}`,
    setState
  );
};
const getPrintHouseMaterialCategoryDataApi: ICallAndSetData = async (
  callApi,
  setState,
  material: {
    materialKey: string;
    categoryKey: string;
    supplierId: string;
    pageNumber: number;
    pageSize: number;
    isActive: boolean;
    customFiltersKeyValueList: IMaterialTableFilteringValue[];
  },
  lock: boolean,
  abortController: AbortController
) => {
  return await getSetApiData(
    callApi,
    EHttpMethod.POST,
    GET_MATERIAL_CATEGORY_DATA_URL,
    setState,
    material,
    lock,
    abortController
  );
};

const getPrintHouseMaterialCategoryDataNewApi: ICallAndSetData = async (
  callApi,
  setState,
  material: {
    materialKey: string;
    categoryKey: string;
    supplierId: string;
    pageNumber: number;
    pageSize: number;
    isActive: boolean;
    customFiltersKeyValueList: IMaterialTableFilteringValue[];
  },
  lock: boolean,
  abortController: AbortController
) => {
  return await getSetApiData(
    callApi,
    EHttpMethod.POST,
    GET_MATERIAL_CATEGORY_DATA_NEW_URL,
    setState,
    material,
    lock,
    abortController
  );
};  
const updatePrintHouseMaterialPropApi: ICallAndSetData = async (
  callApi,
  callBack,
  data
) => {
  return await getSetApiData(
    callApi,
    EHttpMethod.POST,
    UPDATE_MATERIAL_PROPS_URL,
    callBack,
    data,
    false
  );
};

const updatePrintHouseMaterialsPropApi: ICallAndSetData = async (
  callApi,
  callBack,
  data
) => {
  return await getSetApiData(
    callApi,
    EHttpMethod.POST,
    UPDATE_MATERIALS_PROPS_URL,
    callBack,
    data
  );
};
const addPrintHouseMaterialCategoryApi: ICallAndSetData = async (
  callApi,
  callBack,
  category: { materialTypeKey: string; categoryKey: string; imageBase64: any }
) => {
  return await getSetApiData(
    callApi,
    EHttpMethod.POST,
    ADD_MATERIAL_CATEGORY_URL,
    callBack,
    category
  );
};

const updatePrintHouseCategoriesOrderApi: ICallAndSetData = async (
  callApi,
  callBack,
  data
) => {
  return await getSetApiData(
    callApi,
    EHttpMethod.POST,
    UPDATE_MATERIAL_CATEGORY_ORDER_URL,
    callBack,
    data
  );
};

const updateCategoriesOrderApi: ICallAndSetData = async (
  callApi,
  callBack,
  data
) => {
  return await getSetApiData(
    callApi,
    EHttpMethod.POST,
    UPDATE_MATERIAL_ORDER_FOR_CATEGORY_URL,
    callBack,
    data
  );
};

const deletePrintHouseMaterialCategoryApi: ICallAndSetData = async (
  callApi,
  callBack,
  category: { materialTypeKey: string; categoryKey: string }
) => {
  return await getSetApiData(
    callApi,
    EHttpMethod.POST,
    DELETE_MATERIAL_CATEGORY_URL,
    callBack,
    category
  );
};

const addPrintHouseMaterialCategoryRowApi: ICallAndSetData = async (
  callApi,
  callBack,
  row: {
    materialKey: string;
    categoryKey: string;
    rowData: Record<string, IDynamicRowData>;
  }
) => {
  return await getSetApiData(
    callApi,
    EHttpMethod.POST,
    ADD_MATERIAL_CATEGORY_ROW_URL,
    callBack,
    row
  );
};

const addPrintHouseMaterialRowApi: ICallAndSetData = async (
  callApi,
  callBack,
  data: any
) => {
  return await getSetApiData(
    callApi,
    EHttpMethod.POST,
    ADD_PRINTHOUSE_MATERIAL_ROW_URL,
    callBack,
    data
  );
};

const updatePrintHouseMaterialCategoryNameApi: ICallAndSetData = async (
  callApi,
  callBack,
  row: {
    materialTypeKey: string;
    categoryKey: string;
    lang: string;
    displayName: string;
    defaultAttributeValues: {
      attributeName: string;
      value: string;
    }[];
  }
) => {
  return await getSetApiData(
    callApi,
    EHttpMethod.PUT,
    UPDATE_MATERIAL_DISPLAY_NAME_URL,
    callBack,
    row
  );
};

const duplicatePrintHouseMaterialDisplayNameApi: ICallAndSetData = async (
  callApi,
  callBack,
  row: {
    materialTypeKey: string;
    categoryKey: string;
    newCategoryKey: string;
  }
) => {
  return await getSetApiData(
    callApi,
    EHttpMethod.POST,
    DUPLICATE_MATERIAL_CATEGORY_URL,
    callBack,
    row
  );
};

const deletePrintHouseMaterialCategoryRowApi: ICallAndSetData = async (
  callApi,
  callBack,
  row: { rowId: string }
) => {
  return await getSetApiData(
    callApi,
    EHttpMethod.POST,
    DELETE_MATERIAL_CATEGORY_Row_URL,
    callBack,
    row
  );
};

const getMaterialsSizesApi: ICallAndSetData = async (
  callApi,
  callBack,
  data
) => {
  return await getSetApiData(
    callApi,
    EHttpMethod.POST,
    GET_MATERIALS_SIZES_URL,
    callBack,
    data
  );
};
const getPrintHouseMaterialExcelFileApi: ICallAndSetData = async (
  callApi,
  setState,
  material: string
) => {
  return await getSetApiData(
    callApi,
    EHttpMethod.GET,
    `${DOWNLOAD_MATERIAL_EXCEL_FILE}?materialKey=${material}`,
    setState
  );
};
const uploadPrintHouseMaterialExcelFileApi: ICallAndSetData = async (
  callApi,
  callBack,
  data: { key: string; base64: string }
) => {
  return await getSetApiData(
    callApi,
    EHttpMethod.POST,
    UPLOAD_MATERIAL_EXCEL_FILE,
    callBack,
    data
  );
};

const getPrintHouseMaterialRowExcelFileApi: ICallAndSetData = async (
  callApi,
  setState,
  materialKey: string
) => {
  return await getSetApiData(
    callApi,
    EHttpMethod.GET,
    `${DOWNLOAD_MATERIAL_ROW_EXCEL_FILE}/${materialKey}`,
    setState
  );
};

const getPrintHouseMaterialInventoriesExcelFileApi: ICallAndSetData = async (
  callApi,
  setState,
  materialKey: string
) => {
  return await getSetApiData(
    callApi,
    EHttpMethod.GET,
    `${DOWNLOAD_MATERIAL_INVENTORIES_EXCEL_FILE}/${materialKey}`,
    setState
  );
};

const getPrintHouseMaterialInventoriesJobsExcelFileApi: ICallAndSetData = async (
  callApi,
  setState,
  materialKey: string
) => {
  return await getSetApiData(
    callApi,
    EHttpMethod.GET,
    `${DOWNLOAD_MATERIAL_INVENTORIES_JOBS_EXCEL_FILE}/${materialKey}`,
    setState
  );
};

const uploadPrintHouseMaterial1RowExcelFileApi: ICallAndSetData = async (
  callApi,
  callBack,
  data: any
) => {
  return await getSetApiData(
    callApi,
    EHttpMethod.POST,
    UPLOAD_MATERIAL_1_ROW_EXCEL_FILE,
    callBack,
    data
  );
};

const getPrintHouseMaterialExcelTemplateColumnsApi: ICallAndSetData = async (
  callApi,
  setState,
  materialKey: string
) => {
  return await getSetApiData(
    callApi,
    EHttpMethod.GET,
    `${GET_MATERIAL_EXCEL_TEMPLATE_COLUMNS}/${materialKey}`,
    setState
  );
};

const getSupplierInventoriesApi = async (
  callApi: Parameters<ICallAndSetData>[0],
  setState: Parameters<ICallAndSetData>[1],
  printHouseMaterialId: string,
  options?: { includeRecentZeroInventoryRows?: boolean }
) => {
  const queryParams: Record<string, boolean> = {};
  if (options?.includeRecentZeroInventoryRows === true) {
    queryParams.includeRecentZeroInventoryRows = true;
  }
  return await getSetApiData(
    callApi,
    EHttpMethod.GET,
    `${GET_SUPPLIER_INVENTORIES_URL}/${printHouseMaterialId}`,
    setState,
    queryParams
  );
};

const getPurchasePricingApi: ICallAndSetData = async (
  callApi,
  setState,
  printHouseMaterialId: string
) => {
  return await getSetApiData(
    callApi,
    EHttpMethod.GET,
    `${GET_PURCHASE_PRICING_URL}/${printHouseMaterialId}`,
    setState
  );
};

// New supplier inventory management API functions
const getSupplierInventoryUsageApi: ICallAndSetData = async (
  callApi,
  setState,
  supplierInventoryId: string
) => {
  return await getSetApiData(
    callApi,
    EHttpMethod.GET,
    `${GET_SUPPLIER_INVENTORY_USAGE_URL}/${supplierInventoryId}`,
    setState
  );
};

const deleteSupplierInventoryUsageApi: ICallAndSetData = async (
  callApi,
  callBack,
  supplierInventoryUsageId: string
) => {
  return await getSetApiData(
    callApi,
    EHttpMethod.DELETE,
    `${DELETE_SUPPLIER_INVENTORY_USAGE_URL}/${supplierInventoryUsageId}`,
    callBack
  );
};

const updateSupplierInventoryUsageStatusApi: ICallAndSetData = async (
  callApi,
  callBack,
  data: { inventoryUsageId: string; status: number }
) => {
  return await getSetApiData(
    callApi,
    EHttpMethod.PUT,
    UPDATE_SUPPLIER_INVENTORY_USAGE_STATUS_URL,
    callBack,
    data
  );
};

const updateSupplierInventoryUsageQuantityApi: ICallAndSetData = async (
  callApi,
  callBack,
  data: {
    inventoryUsageId: string;
    key: number;
    updatedValue: number;
  }
) => {
  return await getSetApiData(
    callApi,
    EHttpMethod.PUT,
    UPDATE_SUPPLIER_INVENTORY_USAGE_QUANTITY_URL,
    callBack,
    data
  );
};

const deleteSupplierInventoryApi: ICallAndSetData = async (
  callApi,
  callBack,
  supplierInventoryId: string
) => {
  return await getSetApiData(
    callApi,
    EHttpMethod.DELETE,
    `${DELETE_SUPPLIER_INVENTORY_URL}/${supplierInventoryId}`,
    callBack
  );
};

const deletePrintHouseMaterialSupplierApi: ICallAndSetData = async (
  callApi,
  callBack,
  printHouseMaterialSupplierId: string
) => {
  return await getSetApiData(
    callApi,
    EHttpMethod.DELETE,
    `${DELETE_PRINTHOUSE_MATERIAL_SUPPLIER_URL}/${printHouseMaterialSupplierId}`,
    callBack
  );
};

const reorderPrintHouseMaterialsApi: ICallAndSetData = async (
  callApi,
  callBack,
  data: any
) => {
  return await getSetApiData(
    callApi,
    EHttpMethod.PUT,
    REORDER_PRINTHOUSE_MATERIALS_URL,
    callBack,
    data
  );
};

const reorderPrintHouseMaterialSupplierApi: ICallAndSetData = async (
  callApi,
  callBack,
  data: any
) => {
  return await getSetApiData(
    callApi,
    EHttpMethod.PUT,
    REORDER_PRINTHOUSE_MATERIAL_SUPPLIER_URL,
    callBack,
    data
  );
};

const reorderPrintHouseSupplierInventoriesApi: ICallAndSetData = async (
  callApi,
  callBack,
  data: any
) => {
  return await getSetApiData(
    callApi,
    EHttpMethod.PUT,
    REORDER_PRINTHOUSE_SUPPLIER_INVENTORIES_URL,
    callBack,
    data
  );
};

const updateSupplierInventoryApi: ICallAndSetData = async (
  callApi,
  callBack,
  data: any
) => {
  return await getSetApiData(
    callApi,
    EHttpMethod.PUT,
    UPDATE_SUPPLIER_INVENTORY_URL,
    callBack,
    data
  );
};

const addSupplierInventoryApi: ICallAndSetData = async (
  callApi,
  callBack,
  data: any
) => {
  return await getSetApiData(
    callApi,
    EHttpMethod.POST,
    ADD_SUPPLIER_INVENTORY_URL,
    callBack,
    data
  );
};

const updatePrintHouseMaterialRowApi: ICallAndSetData = async (
  callApi,
  callBack,
  data: any
) => {
  return await getSetApiData(
    callApi,
    EHttpMethod.PUT,
    UPDATE_PRINT_HOUSE_MATERIAL_ROW_URL,
    callBack,
    data
  );
};

const updatePrintHouseMaterialsRowsApi: ICallAndSetData = async (
  callApi,
  callBack,
  data: any
) => {
  return await getSetApiData(
    callApi,
    EHttpMethod.PUT,
    UPDATE_PRINT_HOUSE_MATERIALS_ROWS_URL,
    callBack,
    data
  );
};

const updatePrintHouseMaterialSupplierApi: ICallAndSetData = async (
  callApi,
  callBack,
  data: any
) => {
  return await getSetApiData(
    callApi,
    EHttpMethod.POST,
    UPDATE_PRINT_HOUSE_MATERIAL_SUPPLIER_URL,
    callBack,
    data
  );
};

const addPrintHouseMaterialSupplierApi: ICallAndSetData = async (
  callApi,
  callBack,
  data: {
    printHouseMaterialId: string;
    supplierId: string;
    price: number;
    currency: string;
    isActive: boolean;
    stock: number;
    quantity: number;
    supplementTime: number;
    existingSupplierAction: number;
  }
) => {
  return await getSetApiData(
    callApi,
    EHttpMethod.POST,
    ADD_PRINT_HOUSE_MATERIAL_SUPPLIER_URL,
    callBack,
    data
  );
};

const updateSupplierInventoriesActionApi: ICallAndSetData = async (
  callApi,
  callBack,
  data: any
) => {
  return await getSetApiData(
    callApi,
    EHttpMethod.PUT,
    UPDATE_SUPPLIER_INVENTORIES_ACTION_URL,
    callBack,
    data
  );
};

const updatePrintHouseMaterialSuppliersActionApi: ICallAndSetData = async (
  callApi,
  callBack,
  data: any
) => {
  return await getSetApiData(
    callApi,
    EHttpMethod.PUT,
    UPDATE_PRINTHOUSE_MATERIAL_SUPPLIERS_ACTION_URL,
    callBack,
    data
  );
};

const calculatePriceApi: ICallAndSetData = async (
  callApi,
  callBack,
  data: {
    printHouseMaterialId: string;
    price: number;
    currency: string;
    priceIndex: number;
    exchangeRate: number;
    key: string;
  }
) => {
  return await getSetApiData(
    callApi,
    EHttpMethod.PUT,
    CALCULATE_PRICE_URL,
    callBack,
    data
  );
};

const addSupplierInventoryForPurchaseOrderApi: ICallAndSetData = async (
  callApi,
  callBack,
  data: {
    documentType: number;
    documentId: string;
    inventories: Array<{
      printHouseMaterialId: string;
      code: string;
      quantity: number;
      orderedQuantity?: number;
      isActive: boolean;
      purchasePrice: number;
      salePrice: number;
      purchaseCurrency: string;
      saleCurrency: string;
      purchaseOrderItemId: string;
      markReceivingAsCompleted?: boolean;
      allowExceedRemainingQuantity?: boolean;
      isSelectedForIntake?: boolean;
      isSplitPackage?: boolean;
      splitPackageIndex?: number;
      splitPackageCount?: number;
      quantityInPackage?: number;
    }>;
  }
) => {
  // The endpoint uses path parameters, so we need to construct the URL with them
  const url = `${ADD_SUPPLIER_INVENTORY_FOR_PURCHASE_ORDER_URL}/${data.documentType}/${data.documentId}`;
  // The body should be just the inventories array
  const body = data.inventories;
  
  return await getSetApiData(
    callApi,
    EHttpMethod.POST,
    url,
    callBack,
    body
  );
};

const reCalculateDocumentItemsDataFromRowMaterialsApi: ICallAndSetData = async (
  callApi,
  callBack,
  data: {
    supplierId: string;
    printHouseMaterialsIds: string[];
  }
) => {
  return await getSetApiData(
    callApi,
    EHttpMethod.POST,
    RE_CALCULATE_DOCUMENT_ITEMS_DATA_FROM_ROW_MATERIALS_URL,
    callBack,
    data
  );
};

const addDocumentItemsFromMaterialRowsApi: ICallAndSetData = async (
  callApi,
  callBack,
  data: {
    printHouseMaterialIds: string[];
    clientId: string;
    documentId: string;
    documentType: number;
  }
) => {
  return await getSetApiData(
    callApi,
    EHttpMethod.POST,
    ADD_DOCUMENT_ITEMS_FROM_MATERIAL_ROWS_URL,
    callBack,
    data
  );
};

const hasPurchaseOrderInventoryApi: ICallAndSetData = async (
  callApi,
  callBack,
  purchaseOrderItemIds: string[]
) => {
  // Build query string with multiple purchaseOrderItemIds
  const queryParams = purchaseOrderItemIds
    .map((id) => `purchaseOrderItemIds=${encodeURIComponent(id)}`)
    .join("&");
  const url = `${HAS_PURCHASE_ORDER_INVENTORY_URL}?${queryParams}`;
  
  return await getSetApiData(
    callApi,
    EHttpMethod.GET,
    url,
    callBack,
    undefined,
    false // Don't lock screen for this check
  );
};

/** Body: array — matches `PUT /PrintHouseMaterials/returnInventoryUsages`. */
export type ReturnInventoryUsagePayloadItem = {
  inventoryUsageId: string;
  usedQuantity: number;
  remainingQuantity: number;
};

const returnInventoryUsagesApi: ICallAndSetData = async (
  callApi,
  callBack,
  data: ReturnInventoryUsagePayloadItem[]
) => {
  return await getSetApiData(
    callApi,
    EHttpMethod.PUT,
    RETURN_INVENTORY_USAGES_URL,
    callBack,
    data
  );
};

const getLastPrintHouseMaterialCodeApi: ICallAndSetData = async (
  callApi,
  callBack,
  data: { materialTypeKey: string; categoryKey?: string }
) => {
  let url = `${GET_LAST_PRINT_HOUSE_MATERIAL_CODE_URL}/${encodeURIComponent(data.materialTypeKey)}`;
  if (data.categoryKey) {
    url += `?categoryKey=${encodeURIComponent(data.categoryKey)}`;
  }
  return await getSetApiData(
    callApi,
    EHttpMethod.GET,
    url,
    callBack,
    undefined,
    false
  );
};

export {
  getPrintHouseMaterialCategoriesApi,
  getPrintHouseMaterialCategoryDataApi,
  getPrintHouseMaterialCategoryDataNewApi,
  updatePrintHouseMaterialPropApi,
  updatePrintHouseMaterialsPropApi,
  addPrintHouseMaterialCategoryApi,
  deletePrintHouseMaterialCategoryApi,
  addPrintHouseMaterialCategoryRowApi,
  addPrintHouseMaterialRowApi,
  deletePrintHouseMaterialCategoryRowApi,
  getMaterialsSizesApi,
  getPrintHouseMaterialExcelFileApi,
  uploadPrintHouseMaterialExcelFileApi,
  getPrintHouseMaterialRowExcelFileApi,
  getPrintHouseMaterialInventoriesExcelFileApi,
  getPrintHouseMaterialInventoriesJobsExcelFileApi,
  uploadPrintHouseMaterial1RowExcelFileApi,
  getPrintHouseMaterialExcelTemplateColumnsApi,
  updatePrintHouseMaterialCategoryNameApi,
  duplicatePrintHouseMaterialDisplayNameApi,
  updatePrintHouseCategoriesOrderApi,
  updateCategoriesOrderApi,
  getSupplierInventoriesApi,
  getPurchasePricingApi,
  // New supplier inventory management APIs
  getSupplierInventoryUsageApi,
  deleteSupplierInventoryUsageApi,
  updateSupplierInventoryUsageStatusApi,
  updateSupplierInventoryUsageQuantityApi,
  deleteSupplierInventoryApi,
  deletePrintHouseMaterialSupplierApi,
  reorderPrintHouseMaterialsApi,
  reorderPrintHouseMaterialSupplierApi,
  reorderPrintHouseSupplierInventoriesApi,
  updateSupplierInventoryApi,
  addSupplierInventoryApi,
  // New material row update APIs
  updatePrintHouseMaterialRowApi,
  updatePrintHouseMaterialsRowsApi,
  updatePrintHouseMaterialSupplierApi,
  addPrintHouseMaterialSupplierApi,
  // New supplier action APIs
  updateSupplierInventoriesActionApi,
  updatePrintHouseMaterialSuppliersActionApi,
  // Price calculation API
  calculatePriceApi,
  // Add supplier inventory for purchase order API
  addSupplierInventoryForPurchaseOrderApi,
  // Re-calculate document items data from row materials API
  reCalculateDocumentItemsDataFromRowMaterialsApi,
  // Batch add document lines from material rows (saved PO)
  addDocumentItemsFromMaterialRowsApi,
  // Check if purchase order items have inventory API
  hasPurchaseOrderInventoryApi,
  returnInventoryUsagesApi,
  getLastPrintHouseMaterialCodeApi
};
